import React, { useCallback } from 'react'
import { ModelForm, hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withForm = Component => ({ record_id }) => {
  const [, { openDialog }] = hooks.useDialogs()
  const requestlimitorder = hooks.useGlobalFormFunction('companyorderlimit_list', 'requestSubmit')
  const requestSubmitCompanyTemplate = hooks.useGlobalFormFunction('companytemplate_list', 'requestSubmit')

  const formProps = {
    name: 'company_form',
    model_name: 'company',
    record_id,
    related_states: [],
    related_searches: [],
    getEmptyForm: useCallback(Callbacks.getEmptyFormHandler(), []),
    recordToForm: useCallback(Callbacks.recordToFormHandler(record_id), [record_id]),
    recordToState: useCallback(Callbacks.recordToStateHandler(), []),
    formToRecord: useCallback(Callbacks.formToRecordHandler(), []),
    populate: [
      'contacts',
      'contracts',
      'companyusers',
      'contact',
      'info'
    ],
    initialState: { isReadOnly: !!record_id, },
    formToOptions: useCallback(Callbacks.formToOptionsHandler(), []),
    onSubmitSuccess: useCallback(Callbacks.onSubmitSuccessHandler(requestlimitorder, requestSubmitCompanyTemplate), [requestlimitorder, requestSubmitCompanyTemplate]),
    onSubmitFailed: useCallback(Callbacks.onSubmitFailedHandler(openDialog), [openDialog]),
    getFailedNotification: useCallback(Callbacks.getFailedNotificationHandler(), [])
  }
  const mergedProps = {
  }
  return (
    <ModelForm {...formProps}>
      <Component {...mergedProps} />
    </ModelForm>
  )
}

export default withForm
